import React from 'react';
import _ from 'lodash';
import CommonModal from './common/Modal';
import { FormList, FormListItem, FormElement } from '../CommonFormComponents';
import { getOneMasterTypeNameCompanyNumber } from '../../utilities/commonUtil';
import { messageUtility } from '../../utilities/messageUtility';

export const MisregistrationReportDialog = ({
  visible,
  onCancel,
  onLogout,
  onConfirm,
  onChange,
  validate,
  invitationEntities,
  misregistrationReportValues,
}) => {
  const companyUserInvitationStatus =
    invitationEntities.company_user_invitation_status;
  const inviteeCompanyName =
    _.get(companyUserInvitationStatus, 'invitee_company_user.company.name') ||
    '';
  const inviteeCompanyAddress =
    _.get(
      companyUserInvitationStatus,
      'invitee_company_user.company.address'
    ) || '';
  const inviteeOneMasterFlag = _.get(
    companyUserInvitationStatus,
    'invitee_company_user.company.one_master_flag'
  );
  const inviteeCompanyNumber = _.get(
    companyUserInvitationStatus,
    'invitee_company_user.company.company_number'
  );
  const inviteeOneMasterTypeNameCompanyNumber = getOneMasterTypeNameCompanyNumber(
    inviteeOneMasterFlag,
    inviteeCompanyNumber
  );
  const inviterCompanyName =
    _.get(companyUserInvitationStatus, 'inviter_company_user.company.name') ||
    '';
  const inviterUserFullName =
    _.get(companyUserInvitationStatus, 'inviter_company_user.user.fullname') ||
    '';
  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div className='dialog dialog--wide dialog--modal'>
            <div className='dialog__header'>
              <span className='dialog__title'>招待内容誤りの報告</span>
            </div>
            <div className='dialog__body'>
              <p className='dialog__text-box dialog__text'>
                誤った会社に招待されたことを招待者に報告します。
                <br />
                報告を行うと、下記の会社への招待が取り消され招待者に通知されます。
              </p>
              <span className='dialog__text-box dialog__text'>
                会社種別：{inviteeOneMasterTypeNameCompanyNumber}
                <br />
              </span>
              <span className='dialog__text-box dialog__text'>会社名：</span>
              <span className='dialog__text-box dialog__text dialog__text--large text--red--primary'>
                {inviteeCompanyName}
                <br />
              </span>
              <span className='dialog__text-box dialog__text'>住所：</span>
              <span className='dialog__text-box dialog__text dialog__text--large text--red--primary'>
                {inviteeCompanyAddress}
              </span>
              <p className='dialog__text-box dialog__text'>
                <br />
                招待者：{inviterCompanyName}　{inviterUserFullName}様
              </p>
              <p className='dialog__text-box dialog__text'>
                以下に正しい会社情報や、誤った会社に招待されたと判断した理由を入力してください。
              </p>
              <div className='InviteForm form-list__width-20-80'>
                <FormList>
                  <FormListItem label='報告内容' required={true}>
                    <FormElement
                      validate={
                        misregistrationReportValues.errors.invitee_comment
                      }
                    >
                      <textarea
                        className=''
                        name='invitee_comment'
                        maxLength={500}
                        onBlur={event => validate(event)}
                        onChange={event => onChange(event)}
                        style={{ maxWidth: '100%', minWidth: '100%' }}
                      />
                    </FormElement>
                  </FormListItem>
                </FormList>
              </div>
            </div>
            <div className='dialog__footer dialog__footer--horizontal'>
              <button className='btn-fixedsize--sub' onClick={onCancel}>
                {messageUtility.getMessage('I-000-008')}
              </button>
              <button className='btn-fixedsize--sub' onClick={onLogout}>
                保留してログアウト
              </button>
              <button className='btn-fixedsize--negative' onClick={onConfirm}>
                報告して招待を取り消す
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/MisregistrationReportDialog.jsx